// NOTIF-002 — helpers partagés de la modale d'absence & délégation.
// Extraits de AbsenceDialog.tsx pour tenir la limite de 300 lignes et être
// réutilisés par les sous-composants frères (AbsenceOverrideRow, AbsenceCoverageWarning).

import type { Colleague } from '@/hooks/useAbsences'

/** Sentinelle « pas d'override → délégué par défaut » (Radix Select interdit value=""). */
export const DEFAULT_DELEGATE = '__default__'

/** Fin de journée locale (l'absence couvre le jour de fin en entier). */
export function endOfDay(d: Date): Date {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59)
}

export function colleagueLabel(c: Colleague): string {
    return c.full_name || c.email
}
